import { reactive } from 'vue';

export const criarUsuarioPerfil = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdperfil: 0,
        nmperfil: '',
        informacoes: '',
        ativo: 'S',
        ckpadrao_estab: 'N',
        ckpadrao_rt: 'N',
        idlogin: 0
    });
};